/**
 * Where an old `/setup/outreach` link goes now that campaigns live under
 * `/campaigns` (ADR-318, P10/H). Every shape the old page understood still
 * lands somewhere sensible, so a bookmark or a link pasted into a ticket keeps
 * working.
 */
export type LegacyOutreachTarget =
  | { to: '/campaigns/$id/edit'; params: { id: string } }
  | { to: '/campaigns/new' }
  | { to: '/campaigns/rules' }
  | { to: '/campaigns' };

export function legacyOutreachTarget(search: Record<string, unknown>): LegacyOutreachTarget {
  if (typeof search.id === 'string' && search.id) {
    return { to: '/campaigns/$id/edit', params: { id: search.id } };
  }
  if (search.view === 'policy') return { to: '/campaigns/rules' };
  if (search.view === 'create') return { to: '/campaigns/new' };
  return { to: '/campaigns' };
}
